import Settings from 'src/Settings';
import RedesignDescriptor from './layout-redesign';
import RefiveDescriptor from './layout-refive';
import CanteenDescriptor from './layout-canteen';
import AramarkDescriptor from './layout-aramark';
import CompanyKitchenDescriptor from './layout-companykitchen';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getLayoutDescriber() {
  return typeDescriber[Settings.buildType];
}
